import React from "react";
import clsx from "clsx";
import WComponent from "../../../../../../../common/WComponent";

class StepTrace extends WComponent {
	state = { open: false };

	render() {
		let { trace } = this.props;
		let { open } = this.state;
		if (!trace || trace.length === 0) return null;
		return (
			<div className="afs-review__exec-trace">
				<span className="afs-review__exec-trace-toggle" onClick={() => this.update({ open: !open })}>
					{open ? "hide trace" : "trace"}
				</span>
				{open && (
					<div className="afs-review__exec-trace-items">
						{trace.map(function (t, i) {
							let valueStr = typeof t.value === "object" ? JSON.stringify(t.value) : String(t.value);
							return (
								<div key={i} className={clsx("afs-review__exec-trace-item", t.result && "afs-review__exec-trace-item--decision")}>
									<span className="afs-review__exec-trace-check">{t.check}</span>
									<span className="afs-review__exec-trace-value">{valueStr}</span>
									{t.result && <span className="afs-review__exec-trace-result">{"→ " + t.result}</span>}
								</div>
							);
						})}
					</div>
				)}
			</div>
		);
	}
}

export default StepTrace;
